export default "__VITE_ASSET__DdL1zxNh__"